import { Env, readFromEnv } from '@cinch-nx/environments'
import AppleStoreBadge from './assets/app-store-download.svg'
import GooglePlayBadge from './assets/google-play-download.svg'
import styles from './app-store-button.module.css'
import {
  TrackingEvent,
  TrackingEventTypes,
  useAnalytics,
} from '@cinch-nx/shared-analytics'

export type AppStores = 'apple-store' | 'google-play'

interface AppStoreButtonProps {
  store: AppStores
  trackingData?: Pick<TrackingEvent, 'data'>
}

export const AppStoreButton: React.FC<AppStoreButtonProps> = ({
  store,
  trackingData,
}) => {
  const { trackEvent } = useAnalytics()

  const onDownloadLinkClick = () => {
    if (trackingData) {
      const trackingEvent: TrackingEvent = {
        eventName: `App Store Download Link Clicked`,
        type: TrackingEventTypes.ADOBE,
        data: trackingData,
      }
      trackEvent(trackingEvent)
    }
  }

  const isAppleStore = store === 'apple-store'

  const downloadUrl = isAppleStore
    ? readFromEnv(Env.IOSAppStoreUrl)
    : readFromEnv(Env.AndroidAppStoreUrl)

  return (
    <a
      href={downloadUrl}
      onClick={onDownloadLinkClick}
      target="_blank"
      aria-label={`Download on ${
        isAppleStore ? 'the Apple Store' : 'Google Play'
      }`}
    >
      {isAppleStore ? (
        <AppleStoreBadge className={styles.storeButton} />
      ) : (
        <GooglePlayBadge className={styles.storeButton} />
      )}
    </a>
  )
}
